export default class RangeModel {
    #from;
    #to;
    #percentOfFill;
    get percentOfFill() {
        return this.#percentOfFill;
    }

    constructor(from, to) {
        this.#from = from;
        this.#to = to;
    }

    update(newValue) {
        this.#percentOfFill = Math.min((newValue * 100) / (this.#to - this.#from), 100);
    }
}
